import '~/lib/muiLicense';
import '~/styles/index.css';
import { ApolloProvider } from '@apollo/client/react';
import { SnackbarProvider } from 'notistack';
import { StrictMode } from 'react';
import { render } from 'react-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { LiveRegion, announce } from '~/components/LiveRegion';
import { ThemeWrapper } from '~/components/theme';
import { useAutoReloadServiceWorker } from '~/hooks/serviceWorker';
import { client } from '~/lib/apollo';
import { i18n } from '~/lib/i18n';

import { router } from '~/pages';

const App = () => {
  useAutoReloadServiceWorker();
  const { t } = useTranslation();
  const appTitle = t('common.application.title');

  return (
    <StrictMode>
      <HelmetProvider>
        <I18nextProvider i18n={i18n}>
          <ApolloProvider client={client}>
            <ThemeWrapper>
              {/* 6s gives slow readers and magnifier users time; errors persist (api/helpers).
                  Toast text is repeated through the live region, which screen readers announce
                  more reliably than the toast's own role=alert. */}
              <SnackbarProvider
                autoHideDuration={6000}
                maxSnack={3}
                onEntered={(node) => announce(node.textContent ?? '')}
              >
                <Helmet defaultTitle={appTitle} titleTemplate={`${appTitle} - %s`} />
                <LiveRegion />
                <RouterProvider router={router} />
              </SnackbarProvider>
            </ThemeWrapper>
          </ApolloProvider>
        </I18nextProvider>
      </HelmetProvider>
    </StrictMode>
  );
};

render(<App />, document.getElementById('root'));
